import React, { useEffect, useMemo, useRef } from "react";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

import { LICENCE_KEY }
from "../../../constants/charts";


am4core.addLicense(LICENCE_KEY);


export default function InsightsByCategory({
    id,
    title,
    data = [],
    clickFunction
})
{

    const chartRef = useRef(null);


    //--------------------------------------------------------
    // Colours
    //--------------------------------------------------------

    const colours =
    [
        "#ef4444",
        "#f97316",
        "#3b82f6",
        "#14b8a6",
        "#8b5cf6",
        "#ec4899",
        "#84cc16",
        "#06b6d4",
        "#f59e0b",
        "#64748b"
    ];


    //--------------------------------------------------------
    // Convert API data into chart data
    //--------------------------------------------------------

    const chartData =
        useMemo(
            () =>
            {
                return data.map(
                    (item, index) =>
                    ({
                        category: item.name,
                        value: item.total,
                        colour:
                            colours[
                                index % colours.length
                            ]
                    }));
            },
            [data]
        );


    //--------------------------------------------------------
    // Chart
    //--------------------------------------------------------

    useEffect(() =>
    {
        if(!chartData || chartData.length === 0)
        {
            return;
        }


        const chart =
            am4core.create(
                id,
                am4charts.PieChart);


        chart.hiddenState.properties.opacity = 0;

        chart.data = chartData;

        chart.innerRadius =
            am4core.percent(78);

        chart.radius =
            am4core.percent(100);

        chart.padding(0, 0, 0, 0);

        chart.legend = null;


        //----------------------------------------------------
        // Series
        //----------------------------------------------------

        const series =
            chart.series.push(
                new am4charts.PieSeries());


        series.dataFields.category =
            "category";

        series.dataFields.value =
            "value";

        series.dataFields.color =
            "colour";


        series.labels.template.disabled = true;

        series.ticks.template.disabled = true;


        series.slices.template.propertyFields.fill =
            "colour";


        series.slices.template.stroke =
            am4core.color("#ffffff");

        series.slices.template.strokeWidth = 0;

        series.slices.template.strokeOpacity = 1;

        series.slices.template.cornerRadius = 0;


        series.slices.template.tooltipText =
            "{category}: [bold]{value}[/]";


        series.tooltip.getFillFromObject = false;

        series.tooltip.background.fill =
            am4core.color("#111");

        series.tooltip.background.cornerRadius = 6;

        series.tooltip.background.strokeOpacity = 0;

        series.tooltip.label.fill =
            am4core.color("#fff");


        //----------------------------------------------------
        // Click
        //----------------------------------------------------

        series.slices.template.events.on(
            "hit",
            function(ev)
            {
                if(clickFunction)
                {
                    clickFunction(
                        ev.target
                            .dataItem
                            .dataContext);
                }
            });


        //----------------------------------------------------
        // Centre label
        //----------------------------------------------------

        const total =
            chartData.reduce(
                (sum, item) =>
                    sum + item.value,
                0);


        const label =
            chart.seriesContainer.createChild(
                am4core.Label);


        label.html =
            "<div style='text-align:center;'>"
            +
            "<div style='font-size:34px;font-weight:700;color:#222;'>"
            +
            total
            +
            "</div>"
            +
            "<div style='font-size:13px;color:#777;margin-top:4px;'>Total</div>"
            +
            "</div>";


        label.horizontalCenter = "middle";

        label.verticalCenter = "middle";


        //----------------------------------------------------

        chartRef.current = chart;


        return () =>
        {
            chart.dispose();
        };

    }, [id, chartData, clickFunction]);


    //--------------------------------------------------------
    // Total
    //--------------------------------------------------------

    const total =
        chartData.reduce(
            (sum, item) =>
                sum + item.value,
            0);


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                width: "100%",
                height: "100%",

                display: "flex",
                flexDirection: "column"
            }}
        >

            <div
                style={{
                    fontSize: "12px",
                    fontWeight: 500,

                    color: "#222",

                    marginBottom: "14px",

                    textTransform: "uppercase"
                }}
            >
                {title}
            </div>


            <div
                style={{
                    flex: 1,

                    marginTop: "40px",

                    display: "flex",

                    alignItems: "center"
                }}
            >

                <div
                    id={id}

                    style={{
						marginTop:'-40px',
                        width: "120%",
                        height: "100%"
                    }}
                />


             

            </div>

        </div>

    );

}